<template>
	<div class="wrapper-cell">
		<el-input
			v-model="row[column.key]"
			placeholder="请输入联系电话"
			oninput="value=value.replace(/[^0-9]/g,'')"
			@blur="validatePhone"
		></el-input>
        <span v-if="column.required" class="required-star">*</span>
		<div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin';
import { isTel } from '@/utils/reg';

export default {
	name: 'contactPhoneInputCell',
	mixins: [mixin],
	data() {
		return {
			errorMsg: ''
		};
	},
	methods: {
		validatePhone() {
			const value = this.row[this.column.key];
			if (!value) {
				this.errorMsg = '联系电话不可为空';
				return;
			}
			
			if (value.length !== 11) {
				this.errorMsg = '手机号应为11位';
				return;
			}
			
			if (!isTel.test(value)) {
				this.errorMsg = '请输入正确的手机号';
				return;
			}
			
			this.errorMsg = '';
		}
	}
};
</script>

<style scoped>
.wrapper-cell{
    position: relative;
    padding-bottom: 20px;
}
.required-star {
	color: #f56c6c;
    position: absolute;
    left: -12px;
    top: 6px;
}
.error-msg {
	color: #f56c6c;
	font-size: 12px;
    position: absolute;
    left: 2px;
    bottom: 0px;
}
</style>